<div class="border-checkbox-section">
    <div class="border-checkbox-group border-checkbox-group-primary">
        <input type="checkbox" class="border-checkbox" [id]="Index+'informationconfirm'" [(ngModel)]="solution.solutionSteps[Index].actionInformation.requiredConfirm" (ngModelChange)="updateSolution()" name="requiredConfirm"  #requiredConfirm="ngModel">
        <label [for]="Index+'informationconfirm'" class="border-checkbox-label">{{'admin.action_information.required_confirm'|translate}}</label>
    </div>
</div>
<div class="row text-solution">
    <div class="col-lg-8">
        <quill-editor [modules]="modules" [name]="'information'+Index" [(ngModel)]="solution.solutionSteps[Index].actionInformation.message" (ngModelChange)="updateSolution()" ></quill-editor>
    </div>
    <div class="col-lg-4">
        <div class="row token-header">
            <div class="col-md-6">{{'admin.general_items.name' | translate}}</div>
            <div class="col-md-6">{{'global.token' | translate}}</div>
        </div>
        <div *ngFor="let token of tokens; let i = index" class="row">
            <div class="col-md-6">{{token.description}}</div>
            <div class="col-md-6 cursor-pointer" [copy-clipboard]="token.name" (copied)="clipboardUpdated()"
                ngbTooltip="{{'admin.emails.manage.click_to_copy' | translate}}" placement="left">{{token.name}}
            </div>
        </div>
    </div>
</div>